// Minimal `cn` helper used by UI components.
// Returns a single string of space-separated class names, ignoring falsy values.
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default cn;
